import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import { InputComponent } from '@shared/components/input/input.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent, ReactiveFormsModule],
  template: `
    <div class="grid w-96">
      <aux-input
        class="mb-2 w-full"
        required
        [placeholder]="placeText"
        [formControl]="selectedText"
      />
    </div>
  `,
})
export class BudgetCustomCreateComponent {
  placeText = `Name your view, e.g. "Forecast View"`;
  ref = inject<
    CustomOverlayRef<
      unknown,
      {
        textName: string;
      }
    >
  >(CustomOverlayRef);
  public selectedText = new UntypedFormControl('');

  constructor() {
    const ref = this.ref;

    if (ref?.data?.textName) {
      this.selectedText.setValue(ref.data.textName);
    }
  }

  saveText() {
    return this.ref.close({ label: this.selectedText.value });
  }
}
